import { authAxios } from "services";

export const fetchAll = (page) =>
  authAxios().get(`/settings/showroom-subscription-packages/?page=${page}`);

export const fetchOptions = () =>
  authAxios().get(`/settings/showroom-subscription-packages/options`);

export const create = (data) => authAxios().post(`/settings/showroom-subscription-packages`, data);

export const fetchById = (id) => authAxios().get(`/settings/showroom-subscription-packages/${id}`);

export const deleteById = (id) =>
  authAxios().delete(`/settings/showroom-subscription-packages/${id}`);

export const updateById = (id, data) =>
  authAxios().post(`/settings/showroom-subscription-packages/${id}?_method=PUT`, data);
